import InputType from "@/services/Input/InputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari Nomor Penerimaan, atau Nomor PO",
    Type: InputType.Text,
    MaxLength: 100
  },
  Vendor: {
    Label: "Vendor",
    Type: InputType.Text,
    MaxLength: 100
  },
  Date: {
    Label: "Tanggal",
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  },
}